// src/App.tsx
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ErrorBoundary } from './components/common/ErrorBoundary';
// import { AuthProvider } from './contexts/AuthContext';
// import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { AgencyDashboard } from './components/agency/AgencyDashboard';
import { RegistrationPage } from './components/register/RegistrationPage';
import { RegistrationSuccess } from './components/register/RegistrationSuccess';
import { EditPage } from './components/edit/EditPage';
import './App.css';

function App() {
  return (
    <ErrorBoundary>
      {/* <AuthProvider> */}
      <Router>
        <div className="App">
          <Routes>
            {/* 管理画面メインルート（一時的に認証なし） */}
            <Route
              path="/"
              element={<AgencyDashboard />}
              // 認証機能を有効にする場合は以下のコメントアウトを解除してください
              // element={
              //   <ProtectedRoute requireAdmin={true}>
              //     <AgencyDashboard />
              //   </ProtectedRoute>
              // }
            />

            {/* 代理店登録ページ（認証不要・公開） */}
            <Route path="/register" element={<RegistrationPage />} />

            {/* デモ登録ページ（決済不要） */}
            <Route path="/register/demo" element={<RegistrationPage isDemo />} />

            {/* 代理店登録完了ページ（決済成功後） */}
            <Route path="/register/success" element={<RegistrationSuccess />} />

            {/* 代理店編集ページ（認証不要・トークンベース） */}
            <Route path="/edit" element={<EditPage />} />

            {/* 404などの未定義ルートはルートにリダイレクト */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
      {/* </AuthProvider> */}
    </ErrorBoundary>
  );
}

export default App;
